import { render, staticRenderFns } from "./TeamFormUpper18.vue?vue&type=template&id=8b1fe660&scoped=true"
import script from "./TeamFormUpper18.vue?vue&type=script&lang=js"
export * from "./TeamFormUpper18.vue?vue&type=script&lang=js"
import style0 from "./TeamFormUpper18.vue?vue&type=style&index=0&id=8b1fe660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1fe660",
  null
  
)

export default component.exports